<script>
import ModuleTitle from '../common/ModuleTitle.vue'
import TabVertical from 'comp/content/TabVertical'
import Title2Logo from '../common/Title2Logo.vue'

import { richTextImgHandler } from '@/utils/common'
import { getSubPage } from '@/api/pageData'

export default {
  name: 'DialogId2',
  components: { ModuleTitle, TabVertical, Title2Logo },
  props: {
    currentModule: {
      type: Object,
      default: () => {}
    },
    currentModuleItemDataId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      path: this.$route.path,
      pageData: [],
      tabActive: 0,
      currentMemo: {}
    }
  },
  computed: {
    pageDataFilter2Tab() {
      let arr = []
      if (this.pageData) {
        this.pageData.forEach(item => arr.push({ id: item.id, title: item.headline, img: item.photo }))
      }
      return arr
    }
  },
  watch: {
    currentMemo(newVal) {
      this.$nextTick(() => {
        setTimeout(() => {
          const parent = document.querySelector('.dialog-content-main')
          parent.scrollTo({ top: 0, behavior: 'smooth' })
        }, 200)
      })
    }
  },
  created() {
    this.initPageData()
  },
  methods: {
    richTextImgHandler,
    onTabClick(id) {
      this.pageData.forEach((item, idx) => {
        if (item.id === id) {
          this.tabActive = idx
          this.currentMemo = item
        }
      })
    },

    initPageData() {
      const params = {
        titleid: Number(this.currentModule.titleid),
        title: this.currentModule.title,
        subtitle: '',
        userid: localStorage.getItem('screenUserid') || 0,
        village: localStorage.getItem('currentCommunity') || ''
      }
      getSubPage(params).then(res => {
        if (res.code === 0) {
          this.pageData = res.msg[0].list
          // this.currentMemo = this.pageData[0]
          this.pageData.length > 0 && this.pageData.forEach((item, idx) => {
            if (item.id === this.currentModuleItemDataId) this.tabActive = idx
          })
          this.currentMemo = this.pageData[this.tabActive]
        }
      })
    }
  }
}
</script>

<template>
  <div class="dialog-id-2">
    <module-title :title="currentModule.title" margin-bottom="40" />
    <div class="main-container">
      <div class="left-container">
        <title2-logo :headline="currentMemo.headline" />
        <p v-if="currentMemo.createtime" class="time">{{ currentMemo.createtime | formatDate('yyyy-MM-dd') }}</p>
        <p class="rich-text" v-html="richTextImgHandler(currentMemo.memo)"></p>
      </div>
      <div class="right-container">
        <tab-vertical
          :page-data="pageDataFilter2Tab"
          :tab-active="tabActive"
          :has-img="false"
          @onTabClick="onTabClick"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
// 1330
// .dialog-id-2 {
//   display: flex;
// }
.main-container {
  display: flex;
  position: relative;
  margin-top: 60px;
  height: 570px;
  overflow-y: scroll;
  &::-webkit-scrollbar { // chrome/safari
    display: none;
  }
  scrollbar-width: none; // firefox
  -ms-overflow-style: none; // IE10+
}
.left-container {
  width: 710px;
  // margin-left: 440px;
  margin-left: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .time {
    font-size: 14px;
    font-weight: bold;
    color: #B3B3B3;
    margin-top: 20px;
  }
  .rich-text {
    width: 710px;
    margin-top: 25px;
  }
}
.right-container {
  position: fixed;
  margin-left: 910px;
}
</style>
